import { Form, Input, Row, Col, Switch, DatePicker } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';

const EditComponent = (props: any) => {
    const { editMode, defaultService } = props;
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [id, setId] = useState<string>();

    useEffect(() => {
        ref.current?.getRow?.then((res: any) => {
            if (res.success) {
                setId(res?.data?.id);
            }
        })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId: 'legalAgreement',
        displayOptions: {
            width: 1080
        },
        dateOptions: {
            columnNames: ['startDate', 'endDate']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={8}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="id"
                                    name="id"
                                    tooltip='不输入id可生成随机id'>
                                    <Input disabled={editMode === 'NEW' ? false : true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="协议名"
                                    name="agreementName"
                                    rules={[{ required: true, message: '协议名称!' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="起始日期"
                                    name="startDate"
                                    tooltip='充值方案的起始日期'>
                                    <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="结束日期"
                                    name="endDate"
                                    tooltip='充值方案的结束日期'>
                                    <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="版本"
                                    name="version">
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    label="默认"
                                    name="isDefault"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="启用"
                                        unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={16}>
                        <Form.Item
                            label=""
                            name="contacts">
                            <WangeditorV5ForAntD
                                key={id}
                                title='内容'
                                id={`legalAgreement${id}`}
                                displayMode="editor"
                                defaultService={defaultService}
                                style={{ height: 500 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>)
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;